import { CenteredLazyLoading } from "@/controls/LazyLoading";
import {
	BAD_BARS_BG,
	BAD_BARS_HOVER_BG,
	TOO_SHORT_BAR_BG,
	TOO_SHORT_BAR_HOVER_BG,
} from "@/shared/colors";
import Paper from "@mui/material/Paper";
import { SxProps, Theme } from "@mui/material/styles";
import { GridApi, RowClassParams } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { usePiecesTableData } from "../hooks/usePiecesTableData";
import { LengthPieceRow } from "../models/LengthPieceRow";

const TOO_LONG_ROW_CLASS = "too-long-bar-row";
const TOO_SHORT_ROW_CLASS = "too-short-bar-row";

const getRejectedBarRowClass = (
	params: RowClassParams<LengthPieceRow>,
): string | undefined => {
	if (params.data?.IsTooLong) return TOO_LONG_ROW_CLASS;
	if (params.data?.IsTooShort) return TOO_SHORT_ROW_CLASS;
	return undefined;
};

const rejectedBarStyles: SxProps<Theme> = {
	[`& .${TOO_LONG_ROW_CLASS}`]: {
		backgroundColor: BAD_BARS_BG,
	},
	[`& .${TOO_LONG_ROW_CLASS}:hover`]: {
		backgroundColor: `${BAD_BARS_HOVER_BG} !important`,
	},
	[`& .${TOO_SHORT_ROW_CLASS}`]: {
		backgroundColor: TOO_SHORT_BAR_BG,
	},
	[`& .${TOO_SHORT_ROW_CLASS}:hover`]: {
		backgroundColor: `${TOO_SHORT_BAR_HOVER_BG} !important`,
	},
};

type Props = {
	isLoading: boolean;
	rows: LengthPieceRow[];
	setGridApi: (api: GridApi) => void;
};

export const LengthPiecesTable = ({ isLoading, rows, setGridApi }: Props) => {
	const { columnDefs } = usePiecesTableData();

	return (
		<Paper
			elevation={2}
			sx={{ height: "100%", overflow: "hidden", ...rejectedBarStyles }}
		>
			<AgGridReact<LengthPieceRow>
				loading={isLoading}
				rowData={rows}
				columnDefs={columnDefs}
				animateRows
				onGridReady={(params) => setGridApi(params.api)}
				loadingOverlayComponent={CenteredLazyLoading}
				getRowId={(params) => `${params.data.BarId}`}
				getRowClass={getRejectedBarRowClass}
				suppressContextMenu
			/>
		</Paper>
	);
};
